import React from 'react';
import PropTypes from 'prop-types';
import { snakeCase } from 'lodash';
import {
  Wrapper, Inner, CrumbWrapper, Crumb, Divider, BreadcrumbLink
} from './Breadcrumb.style';

import { getsWhiteText } from '../RichText/colourRules';

const Breadcrumb = ({ thisPageTitle, backgroundColour = 'grey_light', parentPages = null }) => {
  // Ensure the breadcrumb text gets coloured appropriately:
  const textColour = getsWhiteText.includes(snakeCase(backgroundColour))
    ? 'white'
    : 'black';

  const characterLimit = 30;
  let formattedPageTitle;

  if (thisPageTitle && thisPageTitle.length > characterLimit) {
    // Chop off the title at our limit...
    let subString = thisPageTitle.substring(0, characterLimit);
    // ...as well as the final word (preceded by a space), so we don't have any partial words:
    subString = subString.substring(0, subString.lastIndexOf(' '));
    // And return with an ellipsis:
    formattedPageTitle = `${subString}...`;
  } else {
    formattedPageTitle = thisPageTitle;
  }

  return (
    <Wrapper>
      <Inner textColour={textColour}>

        {/* Always render 'home' */}
        <CrumbWrapper>
          <Crumb>
            <BreadcrumbLink href="/">
              Home
            </BreadcrumbLink>
          </Crumb>
        </CrumbWrapper>

        <Divider>/</Divider>

        {/* Render every parent page link and title, in
      the order they're provided, IF they're provided: */}
        {parentPages && (
          parentPages.map(thisParentPage => (
            <CrumbWrapper key={thisParentPage.path}>
              <Crumb>
                <BreadcrumbLink href={`/${thisParentPage.path}`}>
                  {thisParentPage.title}
                </BreadcrumbLink>
              </Crumb>

              <Divider>/</Divider>

            </CrumbWrapper>
          ))
        )}

        {/* And finally render the title of THIS page, not as a link: */}
        <CrumbWrapper>
          <Crumb>
            {formattedPageTitle}
          </Crumb>
        </CrumbWrapper>

      </Inner>
    </Wrapper>
  );
};
Breadcrumb.propTypes = {
  thisPageTitle: PropTypes.string.isRequired,
  backgroundColour: PropTypes.string,
  parentPages: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired
    })
  )
};

export default Breadcrumb;
